
const workSpaceHeaderData = [
  {
    link: '/v3/homepage/cases',
    name: 'cases',
    text: '案例与场景',
  },
  {
    link: '/v3/homepage/agent',
    name: 'agent',
    text: '加盟合作',
  },
  {
    link: '/v3/homepage/developer',
    name: 'developer',
    text: '开放平台',
  },
  {
    link: `https://m.kuaizhan.com/90/3/p2649405090dde7`,
    name: 'university',
    text: '快站大学',
  },
  {
    link: '/v3/homepage/about',
    name: 'about',
    text: '关于我们',
  },
  
]

const accountHeaderData = [
  {
      link: '/v4/workspace/',
      name: 'workspace',
      text: '工作台',
  },
  {
      link: `/v3/homepage/pricing`,
      name: 'update',
      text: '升级套餐',
  },
  {
    link: '/v3/homepage/developer',
    name: 'developer',
    text: '开放平台',
  },
  {
    link: `https://m.kuaizhan.com/90/3/p2649405090dde7`,
    name: 'university',
    text: '快站大学',
  }
]

function getHeaderData() {

  const pathname = window.location.pathname
  const siteId = pathname.split('/').filter(item => item).slice(-1)[0]
  const isWorkSpace = pathname.indexOf('workspace') > -1
  const isOfficialAccount = pathname.indexOf('official-accounts') > -1

  let data = [
    {
      link: `/site/site-edit?site_id=${siteId}`,
      name: 'site-edit',
      text: '页面编辑'
    },
    {
        link: '/v4/workspace/',
        name: 'workspace',
        text: '工作台',
    },
    {
        link: '/v3/site',
        name: 'site',
        text: '站点列表',
    },
    {
        link: `/v3/homepage/pricing`,
        name: 'update',
        text: '升级套餐',
    },
    {
      link: `/plugin/?site_id=${siteId}`,
      name: 'cloud-shop',
      text: '云商店',
    },
    {
      link: `https://m.kuaizhan.com/90/3/p2649405090dde7`,
      name: 'university',
      text: '快站大学',
    }
  ];

  if (isWorkSpace) {
    return workSpaceHeaderData;
  }

  if (isOfficialAccount) {
    return accountHeaderData;
  }

  return data;
}

export default getHeaderData;